export default function Features() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: '高清流畅',
      desc: '支持1080P高清播放，智能加载技术确保观看体验丝滑流畅，不卡顿。',
    },
    {
      icon: 'ri-brain-line',
      title: '智能推荐',
      desc: '基于AI算法的个性化推荐系统，越用越懂你，总能发现你感兴趣的好内容。',
    },
    {
      icon: 'ri-group-line',
      title: '海量用户',
      desc: '千万级用户社区，每天数百万条新内容，与志同道合的朋友一起分享快乐。',
    },
    {
      icon: 'ri-edit-2-line',
      title: '轻松创作',
      desc: '内置强大创作工具，一键拍摄、智能剪辑、丰富特效，零基础也能做出精彩视频。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择茄子视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            我们用技术让分享更简单，用内容让生活更精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, idx) => (
            <div key={idx} className="text-center p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-medium text-foreground-900">{feat.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}